import TextField from "@mui/material/TextField";
import { useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";

type Props = {};

export const DownHoursFilter = ({}: Props) => {
	const [searchParams, setSearchParams] = useSearchParams();
	const downHours = searchParams.get("downHours") ?? "";
	const [localValue, setLocalValue] = useState(downHours);

	// Update local value when URL param changes (e.g., from reset)
	useEffect(() => {
		setLocalValue(downHours);
	}, [downHours]);

	// Debounce search param update
	useEffect(() => {
		const timeoutId = setTimeout(() => {
			if (localValue !== downHours) {
				if (localValue === "") {
					searchParams.delete("downHours");
				} else {
					searchParams.set("downHours", localValue);
				}
				setSearchParams(searchParams, { replace: true });
			}
		}, 500);

		return () => clearTimeout(timeoutId);
	}, [localValue, downHours, searchParams, setSearchParams]);

	const handleFilter = (e: any) => {
		setLocalValue(e.target.value);
	};

	return (
		<div style={{ position: "relative" }}>
			<TextField
				sx={{
					"& .MuiFormLabel-root": {
						fontSize: "0.75rem",
						transform: "translate(14px, -9px) scale(1)",
						backgroundColor: "#FFF",
						padding: "0 4px",
					},
					"& .MuiInputBase-input": {
						color: "black",
						paddingRight: "45px",
					},
				}}
				type="number"
				label="Down hours"
				variant="outlined"
				size="small"
				value={localValue}
				onChange={handleFilter}
				fullWidth
				autoComplete="off"
			/>
			<i
				className="fa fa-keyboard"
				style={{
					position: "absolute",
					right: 17,
					top: 20,
					cursor: "pointer",
				}}
			/>
		</div>
	);
};
